import React, { Component } from 'react';
import { observer } from 'mobx-react'
import EngineerStore from './request/model';
import { getWeekList } from './request/dao';
import CarouselCom from './component/Carousel/index';
import classname from 'classnames';
import pictureArr from '../Dashboard/Project/picture/index';
import './index.styl';

const clzpre = 'ssfe-engineering';

@observer
class Engineering extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'currentActiveIndex': 2
        };
        this.testdata = [
            {
                'id': '1',
                'name': 'pic1',
                'urls': [pictureArr[0]],
                'description': 'xxx1'
            },
            {
                'id': '2',
                'name': 'pic2',
                'urls': [pictureArr[1]],
                'description': 'xxx2'
            },
            {
                'id': '3',
                'name': 'pic3',
                'urls': [pictureArr[2]],
                'description': 'xxx3'
            },
            {
                'id': '4',
                'name': 'pic4',
                'urls': [pictureArr[3]],
                'description': 'xxx4'
            },
            {
                'id': '5',
                'name': 'pic5',
                'urls': [pictureArr[4]],
                'description': 'xxx5'
            }
        ];
    }

    componentDidMount() {
        getWeekList();
    }

    /**
     * 生成左侧的总览列表
     * @param data
     * @returns {any[]}
     */
    generateWeekList = (data) => {
        const {
            currentActiveIndex
        } = this.state;
        return (data || []).map((item, index) => {
            return (
                <div
                    className={classname(['single-img'], { 'active-img': currentActiveIndex === index })}
                    onClick={() => {
                        if (currentActiveIndex !== index) {
                            this.setState({ 'currentActiveIndex': index });
                            this.carouselCom.resetPage();
                        }
                    }}
                    title={item.name || ''}
                >
                    <div className={'img-wrapper'}>
                        <img key={index} src={item.urls[0]} alt={item.name} />
                    </div>
                    <span>{item.name || '--'}</span>
                </div>
            );
        });
    };

    /**
     * 根据实时选中的生成切换区域
     * @param currentWeek
     * @returns {({} & {content: *})[]}
     */
    generateRightImg = (currentWeek = {}) => {
        const data = currentWeek.urls || [];
        return (data || []).map((item, index) => {
            return Object.assign({}, currentWeek || {},
                {
                    'content': (<div>
                        <img
                            key={index} src={item} alt={currentWeek.name} style={{ 'height': 488, 'width': 867 }}
                        />
                    </div>)
                });
        });
    };

    changePageByOne = (flag) => {
        if (flag) { }
    };

    render() {
        const { weekList } = this.props.EngineeringStore;
        const { currentActiveIndex } = this.state;

        return (
            <div className={clzpre}>
                <div className={'dsh-box left-wrapper'}>
                    <h3>周报列表</h3>
                    <div className={'week-list'}>
                        <div>
                            {this.generateWeekList(weekList)}
                        </div>
                    </div>
                </div>
                <div className={'right-wrapper'}>
                    <CarouselCom
                        ref={e => this.carouselCom = e}
                        currentActiveIndex={currentActiveIndex}
                        // changeCardOne={(id) => {
                        //     this.setState({
                        //         'currentActiveIndex': id
                        //     });
                        // }}
                    >
                        {this.generateRightImg(weekList[currentActiveIndex])}
                    </CarouselCom>
                </div>
            </div>
        );
    }
}

export default (prosp) => <Engineering {...prosp} EngineeringStore={EngineerStore} />;